import { cn as _cn } from '../../utils/cn';
import Link, { LinkProps } from 'next/link';
import { FC, PropsWithChildren } from 'react';
export type TypeProps = PropsWithChildren<{
  className?: string;
  bold?: boolean;
  autoMargin?: boolean;
}>;
const cn = (className: string, props: TypeProps) => _cn(className, props.className, {
  'my-[1.6em]': props.autoMargin
});
const Heading: FC<Omit<TypeProps, 'className' | 'bold'>> = ({
  children,
  autoMargin
}) => {
  return autoMargin ? <div className="flex items-start lg:items-center" data-sentry-component="Heading" data-sentry-source-file="typography.tsx">
      <div className="flex-1 h-[1px] bg-zinc-200 hidden lg:block" />
      <div className="lg:shrink-0 lg:mx-8 lg:max-w-[60%] lg:text-center">{children}</div>
      <hr className="flex-1 h-[1px] bg-zinc-200 hidden lg:block" />
    </div> : children;
};
export const TypeLink: FC<PropsWithChildren<LinkProps>> = props => <Link className="underline" {...props} data-sentry-element="Link" data-sentry-component="TypeLink" data-sentry-source-file="typography.tsx" />;
export const headingClasses = {
  h1: 'text-5xl md:text-6xl lg:text-7xl !leading-tight',
  h2: 'text-4xl md:text-5xl lg:text-6xl !leading-tight',
  h3: 'text-3xl md:text-4xl lg:text-5xl !leading-tight',
  h4: 'text-2xl md:text-3xl lg:text-4xl !leading-tight',
  h5: 'text-xl md:text-2xl lg:text-3xl !leading-tight',
  h6: 'text-lg md:text-xl lg:text-2xl !leading-tight'
};
export const H1: FC<TypeProps> = props => <Heading {...props} data-sentry-element="Heading" data-sentry-component="H1" data-sentry-source-file="typography.tsx">
    <h1 className={cn(headingClasses.h1, props)}>{props.children}</h1>
  </Heading>;
export const H2: FC<TypeProps> = props => <Heading {...props} data-sentry-element="Heading" data-sentry-component="H2" data-sentry-source-file="typography.tsx">
    <h2 className={cn(headingClasses.h2, props)}>{props.children}</h2>
  </Heading>;
export const H3: FC<TypeProps> = props => <Heading {...props} data-sentry-element="Heading" data-sentry-component="H3" data-sentry-source-file="typography.tsx">
    <h3 className={cn(headingClasses.h3, props)}>{props.children}</h3>
  </Heading>;
export const H4: FC<TypeProps> = props => <Heading {...props} data-sentry-element="Heading" data-sentry-component="H4" data-sentry-source-file="typography.tsx">
    <h4 className={cn(headingClasses.h4, props)}>{props.children}</h4>
  </Heading>;
export const H5: FC<TypeProps> = props => <Heading {...props} data-sentry-element="Heading" data-sentry-component="H5" data-sentry-source-file="typography.tsx">
    <h5 className={cn(headingClasses.h5, props)}>{props.children}</h5>
  </Heading>;
export const H6: FC<TypeProps> = props => <Heading {...props} data-sentry-element="Heading" data-sentry-component="H6" data-sentry-source-file="typography.tsx">
    <h6 className={cn(headingClasses.h6, props)}>{props.children}</h6>
  </Heading>;
export const BlockQuote: FC<TypeProps & {
  variant?: 'line' | 'impact';
}> = ({
  variant = 'line',
  ...props
}) => <blockquote className={cn(_cn({
  'my-4 pl-8 border-l-2 border-primary': variant === 'line',
  'font-bold font-barlow text-xl lg:text-3xl': variant === 'impact'
}), {
  ...props,
  autoMargin: variant === 'line' && props.autoMargin
})} data-sentry-component="BlockQuote" data-sentry-source-file="typography.tsx">
    {props.children}
  </blockquote>;
export const OrderedList: FC<TypeProps> = props => <ol className={cn('list-decimal', props)} data-sentry-component="OrderedList" data-sentry-source-file="typography.tsx">{props.children}</ol>;